import { render, staticRenderFns } from "./subjectTestPerformance.vue?vue&type=template&id=1cc133c6&scoped=true"
import script from "./subjectTestPerformance.vue?vue&type=script&lang=js"
export * from "./subjectTestPerformance.vue?vue&type=script&lang=js"
import style0 from "./subjectTestPerformance.vue?vue&type=style&index=0&id=1cc133c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc133c6",
  null
  
)

export default component.exports